<div class="card log-backup-container">
    <div class="log-backup-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [globalFilterFields]="['id','estacao','tipo_evento', 'situacao', 'inicio', 'fim']"
            [scrollable]="true" [scrollHeight]="scrollHeight">


        <ng-template pTemplate="caption">
            <div class="flex p-flex-column p-flex-md-row align-items-center justify-content-between">
                <h5 class="p-m-0">Log Backup Realizados</h5>
                <span class="p-input-icon-left mt-2 md:mt-0">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Código
                </th>
                <th>Data Inicial
                </th>
                <th>Data Final
                </th>
                <th>Url
                </th>
                <th>Código status
                </th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dt>
            <tr>
                <td><span class="p-column-title negrito">Código: </span>{{dt.id}}</td>
                <td><span class="p-column-title negrito">Data Início: </span>{{dt.data_hora_inicio | date: 'dd/MM/yyyy HH:mm'}}</td>
                <td><span class="p-column-title negrito">Data Fim: </span>{{dt.data_hora_fim}}</td>
                <td><span class="p-column-title negrito">Url: </span>{{dt.url_backup}}</td>
                <td><span class="p-column-title negrito">Código status: </span>{{dt.status}}</td>
            </tr>
        </ng-template>

        </p-table>
    </div>
</div>
